import axios from 'axios'

import authInterceptor from '@/apis/interceptors/auth'

export default authInterceptor(axios.create())



// WEBPACK FOOTER //
// ./src/apis/sms-api/client.js